import { reactive, ref } from 'vue'

const transitionName = ref('zoom')

export { transitionName }
